<template>

  <div>
    <customer-stepper-order v-if="orderSystemIsReady && branchSelectedIsReady" ref="stepper">
      <template v-slot:step1>
        <customer-order-mode @next="nextStep"></customer-order-mode>
      </template>

      <template v-slot:step2>
        <customer-product-gallery @next="nextStep"></customer-product-gallery>
      </template>

      <template v-slot:step3>
        <customer-contact-form @next="nextStep" nextButton email-required></customer-contact-form>
      </template>

      <template v-slot:step4>
        <payment-method @confirm="nextStep" submitButton></payment-method>
      </template>

      <template v-slot:step5>
        <v-container class="pa-0">
          <order-review
              @next="nextStep"
              @orderReview="goToStep(1)"
              @orderCreated="onOrderCreated"
              @editLocation="goToStep(1)"
              @editProducts="goToStep(2)"
              @editContact="goToStep(3)"
              @editPayment="goToStep(4)"
          ></order-review>
        </v-container>
      </template>


    </customer-stepper-order>

    <loading v-else/>

  </div>

</template>

<script>
import {Loading} from "@dracul/common-frontend"
import CustomerOrderMode from "@/modules/delivery/components-core/customer/CustomerOrderMode/CustomerOrderMode.vue";
import CustomerStepperOrder
  from "@/modules/delivery/components-core/customer/CustomerStepperOrder/CustomerStepperOrder.vue";
import CustomerProductGallery
  from "@/modules/delivery/components-core/customer/CustomerProductGallery/CustomerProductGallery.vue";
import CustomerContactForm
  from "@/modules/delivery/components-core/customer/CustomerContactForm/CustomerContactForm.vue";
import PaymentMethod from "@/modules/payment/components/PaymentMethod/PaymentMethod.vue";
import OrderReview
  from "@/modules/delivery/components-core/shared/OrderReview/OrderReview.vue";

export default {
  name: "CustomerOrder",
  components: {
    OrderReview,
    PaymentMethod,
    CustomerContactForm, CustomerProductGallery, CustomerStepperOrder, CustomerOrderMode, Loading
  },
  data() {
    return {
      showConfirmedModal: false
    }
  },
  methods: {

    nextStep() {
      this.$refs.stepper.nextStep();
    },
    goToStep(step) {
      this.$refs.stepper.goToStep(step);
    },
    onOrderCreated() {
      this.$router.push({
        name: 'CustomerOrderCreatedPage',
        params: {identifier: this.orderIdentifier}
      })
    }
  },
  computed: {
    orderSystemIsReady() {
      return this.$store.getters.orderSystem.isSystemReady
    },
    branchSelectedIsReady() {
      return !!this.$store.getters.branchSelected
    },
    orderIdentifier() {
      return this.$store.getters.orderIdentifier
    }
  }
}
</script>

<style scoped>

</style>
